import React from 'react'

import { Icon } from 'src/chrome'
import { useState } from 'src/hooks'

import styles from './floatingDrawer.module.scss'

type FloatingDrawerProps = {
  className: string
  isOpen: boolean
  onClick: () => void
  style?: React.CSSProperties
  triggerTitle: string
  triggerCloseTitle: string
}

const FloatingDrawer: React.FC<FloatingDrawerProps> = props => {
  const [isOpen, setIsOpen] = useState(props.isOpen)

  const toggleDrawer = () => setIsOpen(prevOpen => !prevOpen)

  const {
    children,
    className,
    onClick,
    style,
    triggerCloseTitle,
    triggerTitle,
  } = props

  return (
    <div
      className={
        isOpen
          ? `${styles.floatingDrawer} ${styles.open}`
          : `${styles.floatingDrawer} ${className}`
      }
    >
      <div
        id={!isOpen ? 'customize_btn' : 'return_to_customize'}
        className={
          className && !isOpen ? `${styles.toggle} ${className}` : styles.toggle
        }
        style={style}
        onClick={
          onClick
            ? () => {
                onClick()
                toggleDrawer()
              }
            : toggleDrawer
        }
      >
        {<Icon icon={'PLUS'} />}
        {triggerTitle && (
          <p>
            {!isOpen
              ? triggerTitle
              : isOpen && triggerCloseTitle
              ? triggerCloseTitle
              : 'Close'}
          </p>
        )}
      </div>
      <div className={styles.floatingMenu}>{children}</div>
    </div>
  )
}

export default FloatingDrawer
